module.exports = __webpack_public_path__ + "img/undraw_signal_searching_bhpc.fe65c585.svg";